import { render, staticRenderFns } from "./pie-charge.vue?vue&type=template&id=0efddea5&scoped=true"
import script from "./pie-charge.vue?vue&type=script&lang=js"
export * from "./pie-charge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efddea5",
  null
  
)

export default component.exports